import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { TextField } from "@/shared/components/Form/TextField";
import type {
  PlatformBlockComponent,
  PlatformBlockProps,
} from "../../../types";
import { BlockFormHeader } from "../BlockFormHeader";

const platforms = [
  "GooglePlay",
  "AppStore",
  "Roku",
  "AndroidTv",
  "AppleTV",
  "Chromecast",
];

export const AppsList: PlatformBlockComponent = ({
  name,
}: PlatformBlockProps) => {
  const { t } = useTranslation();

  return (
    <Paper sx={{ p: 2 }}>
      <BlockFormHeader blockType="APPS_LIST" />
      <Grid container spacing={2}>
        <Grid size={12}>
          <TextField
            name={`${name}.title`}
            label={t("platformBlocks.fields.title")}
            type="text"
            fullWidth
          />
        </Grid>
        {platforms.map((platform) => {
          return (
            <Grid key={platform} size={6}>
              <TextField
                name={`${name}.links.${platform}`}
                label={platform}
                type="text"
                fullWidth
              />
            </Grid>
          );
        })}
      </Grid>
    </Paper>
  );
};
